module.exports = __webpack_public_path__ + "static/media/icon-barrel.d7a6d219.png";